import { useMemo } from "react";

export function useAuth0Params() {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const rawSuccess = params.get("success");
    const message = params.get("message") ?? undefined;

    let success: boolean | null = null;
    if (rawSuccess === "true") success = true;
    else if (rawSuccess === "false") success = false;

    return { success, message };
  }, []);
}
